let lastClickTime
const delayTime = 800;
export const isFastDoubleClick=() =>{
  var time = Date.now();
  var timeD = time - lastClickTime;
  if (0 < timeD && timeD < delayTime) {
      return true;
  }
  lastClickTime = time;
  return false;
}



